import { render, staticRenderFns } from "./NotesListNote.vue?vue&type=template&id=21d21e32&"
import script from "./NotesListNote.vue?vue&type=script&lang=js&"
export * from "./NotesListNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports